import React from 'react'
import {
  useEventDefaultForm,
  TestValuesInput,
  TestType,
  EventDefaultFormValues,
  SpecimenList,
} from '@modmd/data'
import { pxToRem } from 'theme'
import { Dialog } from 'components/Dialog'
import Card from 'components/Card'
import { Box } from 'components/Layout'
import Button from 'components/Button'
import { FormikHelpers } from 'formik'
import TestFields from '../TestSessionDetails/TestFields'
import { SPECIMEN_TYPES } from '../TestDetails/SpecimenType'

interface Props {
  testType: TestType
  isOpen?: boolean
  onDismiss: () => void
  onFinish: (values: TestValuesInput) => void
  testValues: TestValuesInput | undefined
}

export const DefaultValuesDialog: React.VFC<Props> = ({
  testType,
  isOpen,
  onDismiss,
  onFinish,
  testValues,
}) => {
  const eventDefaultForm = useEventDefaultForm({
    validationSchema: 'eventDefault',
    onSubmit: (values: TestValuesInput, formikHelpers: FormikHelpers<EventDefaultFormValues>) => {
      if (values.specimenType === '') {
        const { specimenType, ...rest } = values
        onFinish(rest)
      } else onFinish(values)
      formikHelpers.resetForm()
      onDismiss()
    },
  })

  React.useEffect(
    () => {
      if (testValues) {
        void eventDefaultForm.setValues({
          rapidLotNumber: testValues.rapidLotNumber ?? undefined,
          rapidCartridgeExpirationDate: testValues.rapidCartridgeExpirationDate
            ? new Date(testValues.rapidCartridgeExpirationDate)
            : undefined,
          rapidDockId: testValues.rapidDockId ?? undefined,
          rapidSpecimenNumber: testValues.rapidSpecimenNumber ?? undefined,
          rapidExpirationDate: testValues.rapidExpirationDate
            ? new Date(testValues.rapidExpirationDate)
            : undefined,
          specimenType: (testValues?.specimenType as SpecimenList) ?? undefined,
        })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [testValues]
  )

  const handleOnChange = (id: string, value: string | Date) => {
    void eventDefaultForm.setFieldValue(id, value)
  }

  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss} maxWidth={pxToRem(600)}>
      <Card>
        <Card.Title onDismiss={onDismiss}>Set Default Values</Card.Title>
        <Card.Content display="grid" gridGap="1rem">
          <Box>
            <TestFields
              type={testType}
              onChange={handleOnChange}
              getFieldProps={eventDefaultForm.getFieldProps}
              touched={eventDefaultForm.touched}
              errors={eventDefaultForm.errors}
              specimenOptions={[{ value: '', label: '' }, ...SPECIMEN_TYPES]}
            />
          </Box>
          <Card.Actions>
            <Button colorVariant="secondary" mr="0.25rem" onClick={onDismiss}>
              Cancel
            </Button>
            <Button onClick={() => eventDefaultForm.handleSubmit()}>Save</Button>
          </Card.Actions>
        </Card.Content>
      </Card>
    </Dialog>
  )
}
